import {Injectable, inject, signal} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '@shared/model/i18n';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  currentLanguage = signal(Language.EN);
  private readonly translate = inject(TranslateService);

  public init(languages: Language[] = [Language.EN, Language.FR]): void {
    this.translate.addLangs(languages);
    this.translate.setDefaultLang(Language.EN);
    this.translate.use(Language.EN);
  }

  public changeLanguage(langCode: Language): void {
    this.translate.use(langCode).subscribe(() => {
      this.currentLanguage.set(langCode);
    });
  }

  public getCurrentLanguage(): Language {
    return this.currentLanguage();
  }
}
